import { render } from "./GeneralReport.vue?vue&type=template&id=7544d3e8&scoped=true"
import script from "./GeneralReport.vue?vue&type=script&lang=js"
export * from "./GeneralReport.vue?vue&type=script&lang=js"

import "./GeneralReport.vue?vue&type=style&index=0&id=7544d3e8&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7544d3e8"]])

export default __exports__